module.exports = __webpack_public_path__ + "img/mouth5.41a7bc74.png";